import { RiNotificationLine } from 'react-icons/ri';

export const Notification = () => (
  <button type="button" className="btn-actions">
    <RiNotificationLine />
  </button>
);
